import axios from 'axios';
import api from '../config/axios'; // Tu instancia configurada de Axios
import API_ROUTES from '../config/apiRoutes'; // Tu archivo de rutas

// --- Importamos los tipos necesarios ---
import { ApiResponse } from '../interfaces/api.types';
import { Pago, NewPagoFormData } from '../interfaces/pago.types';

/**
 * @function handleApiError
 * @description Función de ayuda para manejar errores de Axios de forma consistente.
 */
const handleApiError = (error: unknown): never => {
    if (axios.isAxiosError(error) && error.response) {
        throw new Error(error.response.data.message || 'Ocurrió un error en el servidor.');
    }
    throw new Error('Ocurrió un error de conexión o un problema desconocido.');
};

/**
 * @function createPago
 * @description Registra un nuevo pago para un caso específico.
 * @param {NewPagoFormData} pagoData - Los datos del nuevo pago.
 * @returns {Promise<Pago>} El objeto del pago recién creado.
 */
export const createPago = async (pagoData: NewPagoFormData): Promise<Pago> => {
    try {
        const response = await api.post<ApiResponse<Pago>>(API_ROUTES.pagos.create, pagoData);
        if (!response.data.success || !response.data.data) {
            throw new Error(response.data.message || "No se pudo registrar el pago.");
        }
        return response.data.data;
    } catch (error) {
        throw handleApiError(error);
    }
};

/**
 * @function deletePago
 * @description Elimina un registro de pago por su ID.
 * @param {number} pagoId - El ID del pago a eliminar.
 * @returns {Promise<string>} Un mensaje de confirmación del backend.
 */
export const deletePago = async (pagoId: number): Promise<string> => {
    try {
        const response = await api.delete<ApiResponse<null>>(API_ROUTES.pagos.delete(pagoId));
        return response.data.message || 'Pago eliminado exitosamente.';
    } catch (error) {
        throw handleApiError(error);
    }
};